<div
  class="fb-like"
  data-href="http://www.facebook.com/isophi.education"
  data-layout="button"
  data-action="like"
  data-size="small"
  data-share="true"
></div>
